export enum SessionEvents {
  TOKEN_ADDED = 'TOKEN_ADDED',
  TOKEN_REMOVED = 'TOKEN_REMOVED',
  SESSION_OBJECTS_CLEARED = 'SESSION_OBJECTS_CLEARED',
  LOGOUT = 'LOGOUT',
}
